module.exports = __webpack_public_path__ + "static/media/tradesmen.aacb359a.png";